import React from "react";

import { Input } from "antd";

import { ReactComponent as SearchIcon } from "../../../assets/icons/Sample Submission Redesign/search-line.svg";

import "./SupplyPickupSearchInput.css";

export default function SupplyPickupSearchInput({
  value = "",
  onChange = () => {},
  onSearch = () => {},
  placeholder = "Search by Order ID",
  disabled = false,
}) {
  const handleSearchOnEnter = (e) => {
    if (e.key === "Enter") {
      onSearch(e.target.value);
    }
  };

  return (
    <Input
      type="search"
      value={value}
      onChange={(e) => {
        const v = e.target.value;
        onChange(v);
        if (!v) onSearch("");
      }}
      onKeyUp={handleSearchOnEnter}
      className="SupplyPickupSearchInput"
      size="large"
      placeholder={placeholder}
      disabled={disabled}
      allowClear
      suffix={(
        <button
          type="button"
          className="SupplyPickupSearchInput__SuffixIcon SupplyPickupSearchInput__SuffixButton"
          aria-label="Search"
          disabled={disabled}
          onClick={() => onSearch(value)}
        >
          <SearchIcon aria-hidden />
        </button>
      )}
    />
  );
}
